// @flow
import React from 'react';

import { Container } from './Body.style';

declare type PropsType = any;
declare type StateType = any;

export default class Body extends React.Component<PropsType, StateType> {
  render(): React$Element<any> {
    const { children } = this.props;
    return <Container className="mdk-header-layout__content page-content">{children}</Container>;
  }
}
